import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { foldDownUpAnimation } from '../../../shared/animations/fold.downUp.animation';

@Component({
    selector: 'mlp-ng-accordion-content',
    templateUrl: 'accordion-content.component.html',
    styleUrls: ['./accordion-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [foldDownUpAnimation]
})
export class AccordionContentComponent {
    @Input() open = false;
    @Input() title: string;

    @Output() toggle: EventEmitter<any> = new EventEmitter();
}
